exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* COLOR VARIABLE */\n.wrap-verify-type {\n  margin: 40px 0; }\n  .wrap-verify-type h3 {\n    font-size: 24px; }\n  .wrap-verify-type input {\n    border: none;\n    border-bottom: 1px solid #dedede;\n    width: 100%;\n    margin: 20px 0;\n    font-size: 14PX;\n    font-family: 'helveticaneuemedium'; }\n  .wrap-verify-type .verify-btn {\n    text-align: right; }\n    .wrap-verify-type .verify-btn button {\n      border: none;\n      background: #572f76;\n      color: #ffffff;\n      border-radius: 30px;\n      padding: 5px 15px;\n      margin-left: 10px;\n      cursor: pointer;\n      text-transform: uppercase;\n      font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/pre-check-product/pre-check-product.component.scss
// module id = ../../../../../src/app/components/pre-check-product/pre-check-product.component.scss
// module chunks = main